import React from 'react';

type TrendingIconProps = React.SVGProps<SVGSVGElement>;

export const TrendingIcon: React.FC<TrendingIconProps> = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <path d="M8 3.5H11V6.5" stroke="#155DFC" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11 3.5L6.75 7.75L4.25 5.25L1 8.5"
      stroke="#155DFC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

TrendingIcon.displayName = 'TrendingIcon';

export default TrendingIcon;
